(function() { window.GUID_4b927825_d48a_4893_b7bf_10b05e2c6deb = { getGuid: function() { return "4b927825-d48a-4893-b7bf-10b05e2c6deb"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarAlignment;
        (function (SnackbarAlignment) {
            SnackbarAlignment[SnackbarAlignment["TopLeft"] = 0] = "TopLeft";
            SnackbarAlignment[SnackbarAlignment["TopCenter"] = 1] = "TopCenter";
            SnackbarAlignment[SnackbarAlignment["TopRight"] = 2] = "TopRight";
            SnackbarAlignment[SnackbarAlignment["MiddleLeft"] = 3] = "MiddleLeft";
            SnackbarAlignment[SnackbarAlignment["MiddleCenter"] = 4] = "MiddleCenter";
            SnackbarAlignment[SnackbarAlignment["MiddleRight"] = 5] = "MiddleRight";
            SnackbarAlignment[SnackbarAlignment["BottomLeft"] = 6] = "BottomLeft";
            SnackbarAlignment[SnackbarAlignment["BottomCenter"] = 7] = "BottomCenter";
            SnackbarAlignment[SnackbarAlignment["BottomRight"] = 8] = "BottomRight";
        })(SnackbarAlignment = Enumeration.SnackbarAlignment || (Enumeration.SnackbarAlignment = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarAlignment.pre.js.map
